export const NotificationPreferenceMessages = {
  notifPreference: {
    email: {
      id: 'notifications.Preference.Email',
      defaultMessage: 'Email',
    },
    sms: {
      id: 'notifications.Preference.Sms',
      defaultMessage: 'SMS',
    },
    and: {
      id: 'notifications.Preference.And',
      defaultMessage: 'and',
    },
    FieldName: {
      id: 'notifications.Preference.FieldName',
      defaultMessage: 'follow-up date',
    },
    Off: {
      id: 'notifications.Preference.Off',
      defaultMessage: 'Off',
    },
    BeginningOfMonth: {
      id: 'notifications.Preference.BeginningOfMonth',
      defaultMessage: 'Monthly Digest',
    },
    BeginningOfWeek: {
      id: 'notifications.Preference.BeginningOfWeek',
      defaultMessage: 'Weekly Digest',
    },
    FourWeeks: {
      id: 'notifications.Preference.FourWeeks',
      defaultMessage: '4 weeks before',
    },
    OnDayOf: {
      id: 'notifications.Preference.OnDayOf',
      defaultMessage: 'On day of',
    },
    OneDay: {
      id: 'notifications.Preference.OneDay',
      defaultMessage: '1 day before',
    },
    OneWeek: {
      id: 'notifications.Preference.OneWeek',
      defaultMessage: '1 week before',
    },
    ThreeDays: {
      id: 'notifications.Preference.ThreeDays',
      defaultMessage: '3 days before',
    },
    ThreeWeeks: {
      id: 'notifications.Preference.ThreeWeeks',
      defaultMessage: '3 weeks before',
    },
    TwoDays: {
      id: 'notifications.Preference.TwoDays',
      defaultMessage: '2 days before',
    },
    TwoWeeks: {
      id: 'notifications.Preference.TwoWeeks',
      defaultMessage: '2 weeks before',
    },
  },
};
